export const GET_CLASS_DASHBOARD_ASSIGNMENTS_USE_CASE = 'GET_CLASS_DASHBOARD_ASSIGNMENTS_USE_CASE';
